import { render, staticRenderFns } from "./presentation-version-upgrade.html?vue&type=template&id=b0e80314&scoped=true&external"
import script from "./presentation-version-upgrade.js?vue&type=script&lang=js&external"
export * from "./presentation-version-upgrade.js?vue&type=script&lang=js&external"
import style0 from "./presentation-version-upgrade.scss?vue&type=style&index=0&id=b0e80314&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e80314",
  null
  
)

export default component.exports